<div class="issues-container">
	<div class="issues-top-elements">
		@if (issue() === 'wait') {
			<div class="issues-emoji">🏋️‍♀️</div>
			<div class="issues-title">{{ waitTitle }}</div>
			<div class="issues-subtitle">{{ waitSubtitle }}</div>
		} @else {
			<div class="issues-title-error">{{ errorTitle }}</div>
			<div class="issues-subtitle">{{ errorSubtitle }}</div>
		}
	</div>
	<div class="issues-bottom-elements">
		<div class="issues-text">Still having issues?</div>
		<sp-button
			prefixImageUrl="mail"
			label="Contact Us"
			type="rectangle"
			[outlined]="true"
			(click)="sendEmail()"
		></sp-button>
	</div>
</div>
